import { Box, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import withMatchingProducts from "areas/product/hoc/with-matching-products"

import { Section } from "./components"
import ProductsList from "./products-list"

const Container = styled(Flex).attrs({
  borderColor: "#d9d9d9",
  borderStyle: "solid none",
  borderWidth: "1px",
  flexDirection: { _: "column", desktop: "row" },
  mx: { _: 2, desktop: 0 },
  px: { desktop: 4 },
  py: { desktop: "10px" },
})``

const RecommendTitle = styled(Typography).attrs((props) => ({
  as: "h3",
  fontSize: "20px",
  fontWeight: "500",
  lineHeight: "28px",
  mb: { desktop: "10px" },
  mt: { _: 3, desktop: 0 },
  textAlign: { _: "center", desktop: "left" },
  ...props,
}))``

const ProductRecommendations = ({ pairsWell, recommended }) => {
  if (pairsWell.length + recommended.length === 0) return null

  return (
    <Section data-cy="product-recommendations" pt={{ desktop: 3 }}>
      <Container>
        {pairsWell.length > 0 && (
          <Box
            width="100%"
            {...(recommended.length > 0 && {
              borderBottom: { _: "1px solid #d9d9d9", desktop: "none" },
              borderRight: { desktop: "1px solid #d9d9d9" },
              maxWidth: { desktop: "50%" },
              minWidth: { desktop: "160px" },
              overflowX: { desktop: "auto" },
              pr: { desktop: "10px" },
              width: { desktop: "auto" },
            })}
          >
            <RecommendTitle key="matching-title">
              PAIRS WELL WITH
            </RecommendTitle>
            <Box mr={{ _: -2, desktop: 0 }}>
              <ProductsList
                displayArrows={{
                  _: "none",
                  desktop: pairsWell.length > 3 ? "flex" : "none",
                  tablet: pairsWell.length > 2 ? "flex" : "none",
                }}
                key="matching-list"
                linkClickData="pairs-well-with-product-list"
                name="Pairs well with"
                products={pairsWell}
              />
            </Box>
          </Box>
        )}
        {recommended.length > 0 && (
          <Box
            flex="1 1"
            width="100%"
            {...(pairsWell.length > 0 && {
              overflowX: { desktop: "auto" },
              pl: { desktop: "10px" },
              width: { desktop: "auto" },
            })}
          >
            <RecommendTitle key="matching-title">
              YOU MAY ALSO LIKE
            </RecommendTitle>
            <Box mr={{ _: -2, desktop: 0 }}>
              <ProductsList
                displayArrows={{
                  _: "none",
                  desktop: recommended.length > 3 ? "flex" : "none",
                  tablet: recommended.length > 2 ? "flex" : "none",
                }}
                key="matching-list"
                linkClickData="ymal-product-list"
                name="You may also like"
                products={recommended}
              />
            </Box>
          </Box>
        )}
      </Container>
    </Section>
  )
}

ProductRecommendations.propTypes = {
  pairsWell: PropTypes.array.isRequired,
  recommended: PropTypes.array.isRequired,
}

export default withMatchingProducts(ProductRecommendations)
